"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EarnMode = exports.DeviceType = exports.TicketEntryMethod = exports.AttributeType = exports.PrizeType = exports.TicketStatus = exports.PromoCodeScanAction = exports.TicketCheckingScanAction = exports.UPDATE_SCANNED_TICKET_CHECKER = exports.RESET_SCANNED_TICKET_CHECKER = exports.ADD_SCANNED_TICKET_CHECKER = exports.RESET_ERROR_VALIDATIONS = exports.CLEAR_VALIDATIONS = exports.ENTER_TICKET_BAR_CODE = exports.FETCH_DRAWS_BY_IDS = exports.RESET_PREVIOUS_PRIZES = exports.SET_PREVIOUS_PRIZES = exports.CLEAR_PRIZES = exports.UPDATE_ATTR = exports.ENTER_TICKET = exports.CLEAR_ERROR = exports.RESET = void 0;
var PrizeType;
(function (PrizeType) {
    PrizeType["COUPON"] = "COUPON";
    PrizeType["LOYALTY_POINTS"] = "LOYALTY_POINTS";
    PrizeType["ENTRY"] = "ENTRY";
    PrizeType["TOKENS"] = "TOKENS";
    PrizeType["BONUS_CAMPAIGN"] = "BONUS_CAMPAIGN";
})(PrizeType || (exports.PrizeType = PrizeType = {}));
var AttributeType;
(function (AttributeType) {
    AttributeType["GROUP"] = "GROUP";
    AttributeType["PREASSIGNED_ENTRY"] = "PREASSIGNED_ENTRY";
    AttributeType["PREASSIGNED_LOYALTY_POINTS"] = "PREASSIGNED_LOYALTY_POINTS";
})(AttributeType || (exports.AttributeType = AttributeType = {}));
var TicketEntryMethod;
(function (TicketEntryMethod) {
    TicketEntryMethod["SCAN"] = "SCAN";
    TicketEntryMethod["MANUAL"] = "MANUAL";
    TicketEntryMethod["ONLINE"] = "ONLINE";
})(TicketEntryMethod || (exports.TicketEntryMethod = TicketEntryMethod = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType["IOS"] = "IOS";
    DeviceType["ANDROID"] = "ANDROID";
    DeviceType["WEB"] = "WEB";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
var EarnMode;
(function (EarnMode) {
    EarnMode["WINNING_TICKETS"] = "WINNING_TICKETS";
    EarnMode["NON_WINNING_TICKETS"] = "NON_WINNING_TICKETS";
    EarnMode["WINNING_AND_NON_WINNING"] = "WINNING_AND_NON_WINNING";
    EarnMode["ALL"] = "ALL";
})(EarnMode || (exports.EarnMode = EarnMode = {}));
var TicketStatus;
(function (TicketStatus) {
    TicketStatus["PENDING"] = "PENDING";
    TicketStatus["CANCELLED"] = "CANCELLED";
    TicketStatus["VERIFIED"] = "VERIFIED";
    TicketStatus["REWARDED"] = "REWARDED";
    TicketStatus["INVALID_REWARDED"] = "INVALID_REWARDED";
    TicketStatus["INVALID"] = "INVALID";
})(TicketStatus || (exports.TicketStatus = TicketStatus = {}));
var TicketCheckingScanAction;
(function (TicketCheckingScanAction) {
    TicketCheckingScanAction["CHECK_INSTANT_TICKET_BAR_CODE"] = "ticket/CHECK_INSTANT_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_DRAW_TICKET_BAR_CODE"] = "ticket/CHECK_DRAW_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_FAST_PLAY_TICKET_BAR_CODE"] = "ticket/CHECK_FAST_PLAY_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_QUICK_CARD_TICKET_BAR_CODE"] = "ticket/CHECK_QUICK_CARD_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_MN_SCRATCH_TICKET_BAR_CODE"] = "ticket/CHECK_MN_SCRATCH_TICKET_BAR_CODE";
    TicketCheckingScanAction["CHECK_SCRATCH_TICKET_BAR_CODE"] = "ticket/CHECK_SCRATCH_TICKET_BAR_CODE";
})(TicketCheckingScanAction || (exports.TicketCheckingScanAction = TicketCheckingScanAction = {}));
var PromoCodeScanAction;
(function (PromoCodeScanAction) {
    PromoCodeScanAction["CHECK_PROMO_CODE_BAR_CODE"] = "promoCode/CHECK_PROMO_CODE_BAR_CODE";
})(PromoCodeScanAction || (exports.PromoCodeScanAction = PromoCodeScanAction = {}));
const RESET = 'ticket/RESET';
exports.RESET = RESET;
const ENTER_TICKET = 'ticket/ENTER_TICKET';
exports.ENTER_TICKET = ENTER_TICKET;
const ENTER_TICKET_BAR_CODE = 'ticket/ENTER_TICKET_BAR_CODE';
exports.ENTER_TICKET_BAR_CODE = ENTER_TICKET_BAR_CODE;
const CLEAR_ERROR = 'ticket/CLEAR_ERROR';
exports.CLEAR_ERROR = CLEAR_ERROR;
const UPDATE_ATTR = 'ticket/UPDATE_ATTR';
exports.UPDATE_ATTR = UPDATE_ATTR;
const CLEAR_PRIZES = 'ticket/CLEAR_PRIZES';
exports.CLEAR_PRIZES = CLEAR_PRIZES;
const SET_PREVIOUS_PRIZES = 'ticket/SET_PREVIOUS_PRIZES';
exports.SET_PREVIOUS_PRIZES = SET_PREVIOUS_PRIZES;
const RESET_PREVIOUS_PRIZES = 'ticket/RESET_PREVIOUS_PRIZES';
exports.RESET_PREVIOUS_PRIZES = RESET_PREVIOUS_PRIZES;
const FETCH_DRAWS_BY_IDS = 'ticket/FETCH_DRAWS_BY_IDS';
exports.FETCH_DRAWS_BY_IDS = FETCH_DRAWS_BY_IDS;
const CLEAR_VALIDATIONS = 'ticket/CLEAR_VALIDATIONS';
exports.CLEAR_VALIDATIONS = CLEAR_VALIDATIONS;
const RESET_ERROR_VALIDATIONS = 'ticket/RESET_ERROR_VALIDATIONS';
exports.RESET_ERROR_VALIDATIONS = RESET_ERROR_VALIDATIONS;
const ADD_SCANNED_TICKET_CHECKER = 'ticket/ADD_SCANNED_TICKET_CHECKER';
exports.ADD_SCANNED_TICKET_CHECKER = ADD_SCANNED_TICKET_CHECKER;
const RESET_SCANNED_TICKET_CHECKER = 'ticket/RESET_SCANNED_TICKET_CHECKER';
exports.RESET_SCANNED_TICKET_CHECKER = RESET_SCANNED_TICKET_CHECKER;
const UPDATE_SCANNED_TICKET_CHECKER = 'ticket/UPDATE_SCANNED_TICKET_CHECKER';
exports.UPDATE_SCANNED_TICKET_CHECKER = UPDATE_SCANNED_TICKET_CHECKER;
//# sourceMappingURL=types.js.map